import Cookies from 'js-cookies';

export function setUserCookies(){
    Cookies.setItem('user', true);
}

export function userIsConnected(){
    return Cookies.getItem('user');
}